import { render, staticRenderFns } from "./QueryAssist.vue?vue&type=template&id=28924b34&scoped=true&"
import script from "./QueryAssist.vue?vue&type=script&lang=js&"
export * from "./QueryAssist.vue?vue&type=script&lang=js&"
import style0 from "./QueryAssist.vue?vue&type=style&index=0&id=28924b34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28924b34",
  null
  
)

export default component.exports